import { isDefined } from '@nfctron/nexus-core';

import { useRouter } from 'next/router';

/**
 * UseRouterParams hook to make it easier to get params from the router
 * @author filipditrich <ditrich@nfctron.com>
 * @returns {URLSearchParams}
 */
export const useRouterParams = (): URLSearchParams => {
	const router = useRouter();
	return isDefined(router.query) ? new URLSearchParams(router.query as any) : new URLSearchParams();
};
